import { Contract } from "@ethersproject/contracts";
import { useMemo } from "react";
import { useEthersSigner } from "./useEthersSigner";
import { provider } from "utils/providers";
import { supportChain } from "@/utils/constant";
import { useChainId } from "wagmi";

export default function useContract<T extends Contract = Contract>(
  address: string,
  ABI: any
): T | null {
  const signer = useEthersSigner();
  const chainId = useChainId();

  return useMemo(() => {
    if (!address || !ABI || !provider) {
      return null;
    }

    try {
      const isSupportedChain = Number(chainId) === Number(supportChain);
      const library = !!signer && isSupportedChain ? signer : provider;
      return new Contract(address, ABI, library);
    } catch (error) {
      console.error("Failed To Get Contract", error);

      return null;
    }
  }, [address, ABI, signer, chainId]) as T;
}
